import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { resetStore } from 'src/store';

import { serializeError } from 'src/utils/redux';
import { getUserPermissionsByCompany } from 'src/api/clientPortal/permissions';

import { UserPermissionResponse, ServerFormErrors } from 'src/types';

type UserProductPermissionsState = {
  isLoading: boolean;
  loadedCompanyId: string;
  permissions: UserPermissionResponse[];
  serverErrors: ServerFormErrors;
};

type FetchUserProductPermissionsParams = {
  userId: string;
  companyId: string;
};

export const fetchUserProductPermissionsAction = createAsyncThunk(
  'userProductPermissions/fetchUserProductPermissionsAction',
  async ({ userId, companyId }: FetchUserProductPermissionsParams) => {
    const res = await getUserPermissionsByCompany(userId, companyId);
    return res.data;
  },
  {
    serializeError,
  },
);

const initialState: UserProductPermissionsState = {
  isLoading: false,
  loadedCompanyId: '',
  permissions: [],
  serverErrors: [],
};

const userProductPermissionsSlice = createSlice({
  name: 'userProductPermissions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUserProductPermissionsAction.pending, (state: UserProductPermissionsState) => {
      state.isLoading = true;
      state.serverErrors = [];
    });
    builder.addCase(fetchUserProductPermissionsAction.fulfilled, (state: UserProductPermissionsState, action) => {
      state.isLoading = false;
      state.loadedCompanyId = action.meta.arg.companyId;
      state.permissions = action.payload;
    });
    builder.addCase(fetchUserProductPermissionsAction.rejected, (state: UserProductPermissionsState, action) => {
      state.isLoading = false;
      state.loadedCompanyId = action.meta.arg.companyId;
      state.permissions = [];
      state.serverErrors = action.error.message ? [action.error.message] : [];
    });

    // Cleanup
    builder.addCase(resetStore, (state: UserProductPermissionsState) => {
      Object.assign(state, initialState);
    });
  },
});

export default userProductPermissionsSlice.reducer;
